// §5.3 — `unwrap()` collapses { data, error } from openapi-fetch into
// a thrown ApiError or the typed payload. Per-feature wrappers call this.

export type ApiResult<T> = { data?: T; error?: unknown; response: Response };

export class ApiError extends Error {
  readonly status: number;
  readonly body: unknown;
  constructor(status: number, body: unknown, message = "AdminApiError") {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.body = body;
  }
}

export function unwrap<T>(result: ApiResult<T>): T {
  if (result.data !== undefined) {
    return result.data;
  }
  throw new ApiError(
    result.response.status,
    result.error,
    `API request failed (${result.response.status})`,
  );
}
